// Default Firebase Hosting domain for now — update this (and
// public/robots.txt's Sitemap: line) again once a custom domain is attached
// in Firebase Hosting, then rebuild + redeploy. Used for canonical URLs,
// Open Graph tags, JSON-LD, sitemap.xml generation, and robots.txt.
export const SITE_URL = 'https://turbo-surge.web.app';
export const SITE_NAME = 'Turbo Surge';
